module.exports = __webpack_public_path__ + "static/poster_mod_improve-7e5a08e31a3bf822848f88aa466e7610.jpg";